
export class Saseung3 {
  id: string;
  hangul: string;
  hanja: string;
  four_tones: string;
  meaning: string;
  order1: string;
  bookmark: boolean;

  constructor(obj?: any) {
    this.id         = (obj && obj.id)         ?? '';
    this.hangul     = (obj && obj.hangul)     ?? '';
    this.hanja      = (obj && obj.hanja)      ?? '';
    this.four_tones = (obj && obj.four_tones) ?? '';
    this.meaning    = (obj && obj.meaning)    ?? '';
    this.order1     = (obj && obj.order1)     ?? '';
    this.bookmark   = (obj && obj.bookmark)   ? !!obj.bookmark : false;
  }
}
